<template>
    <div class="py-4 container-fluid px-0">
        <div class=" row">
            <div class="col-12">
                <div class="card card-plain border border-info">
                    <div class="card-header text-start bg-info">
                        <div class="d-flex align-items-center">
                            <p class="text-uppercase text-sm text-white">수당 내역</p>
                        </div>
                    </div>
                    <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
                        <div class="table-responsive p-0">
                            <table class="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">금액</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">받을주소</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">타입</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">상태</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">처리일</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in list" :key="index">
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <div class="d-flex flex-column justify-content-center">
                                                    <h6 class="mb-0 text-sm">{{item.balance}}</h6>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <div class="d-flex flex-column justify-content-center">
                                                    <h6 class="mb-0 text-sm">{{item.address}}</h6>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <div class="d-flex flex-column justify-content-center">
                                                    <h6 class="mb-0 text-sm">{{CheckType(item.type)}}</h6>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <div class="d-flex flex-column justify-content-center">
                                                    <span class="badge badge-lg bg-gradient-primary" v-if="item.status =='Y'">처리완료</span>
                                                    <span class="badge badge-lg bg-gradient-warning" v-if="item.status =='H'">전송 대기</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <div class="d-flex flex-column justify-content-center">
                                                    <h6 class="mb-0 text-sm">{{item.update_time}}</h6>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr class="horizontal dark" />
                        <ul class="pagination pagination-primary pagination-sm d-flex justify-content-center">
                            <li class="page-item" v-if="max_page > 5">
                                <a class="page-link" href="javascript:void(0);" @click="PrevPage()">
                                    <i class="fa fa-angle-left"></i>
                                </a>
                            </li>
                            <li class="page-item " :class="CheckPage(n)" v-for="n in max_page" :key="'Page_'+n">
                                <a class="page-link" href="javascript:void(0);"  @click="ClickPaging(n)">
                                    {{n}}
                                </a>
                            </li>
                            <li class="page-item"  v-if="max_page > 5" >
                                <a class="page-link" href="javascript:void(0);" @click="NextPage()">
                                    <i class="fa fa-angle-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const exactMath = require('exact-math');
const CryptoJS = require("crypto-js");

export default {
    name: "tables",
    components:{},
    data() {
        return {
            limit : 5,
            page : 1,
            max_page : 0,
            show : 3,
            list : [],
            no :this.$route.params.no,
        };
    },
    mounted(){
        this.GetList();
    },
    methods:{
        CheckType(type){
            if(type=='R'){
                return "추천인"
            }else if(type=='C'){
                return "회사 보너스"
            }else if(type=='G'){
                return "직급 보너스"
            }
        },
        ClickPaging(i){
            this.page =i;
            this.GetList();
        },
        CheckPage(i){
            const show = this.show;
            const page = this.page;
            var add_class ='';
            if((i+2) == show){
                if(page ==i){
                    add_class = " active ";
                }
            }else if((i+1) == show){
                if(page ==i){
                    add_class = " active ";
                }
            }else if((i) == show){
                if(page ==i){
                    add_class = " active ";
                }
            }else if((i-1) == show){
                if(page ==i){
                    add_class = " active ";
                }
            }else if((i-2) == show){
                if(page ==i){
                    add_class = " active ";
                }
            }else{
                add_class += 'd-none';
            }

            return add_class;
        },
        PrevPage(){
            const show = this.show;
            const show_prev = exactMath.sub(show,1);

            if(show_prev >= 3){
                this.show = show_prev;
            }else{
                this.show = show;
            }
        },
        NextPage(){
            const show = this.show;
            const show_next = exactMath.add(show,1);
            
            const max = exactMath.sub(this.max_page,2);
            
            if(show_next <= max){
                this.show = show_next;
            }else{
                this.show = max;
            }
        },
        GetList(){
            const code = this.no;
            const page = this.page;
            const limit = this.limit;
            const body = {code,page,limit};
            const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
            this.axios.post('/admin/member/DetailExtraList', {req}).then(
                res => {
                    if(res.status ==200){
                        if(res.data.code=='200'){
                            const e_body = res.data.body;
                            const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
                            const d_res = bytes.toString(CryptoJS.enc.Utf8);
                            const body = JSON.parse(d_res)
                            this.max_page = body.count;
                            this.list = body.list;
                        }else if(res.data.code=='9999'){
                            this.$store.dispatch('SETLOGOUT').then(
                                ()=>{
                                    window.location.href="/login";
                                }
                            )
                        }
                    }
                }
            )
        },
    }
};
</script>
